var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticStyle:{"z-index":"1"}},_vm._l((_vm.schoolListShow),function(school){return _c('van-cell',{key:school,attrs:{"title":school},on:{"click":function($event){return _vm.confirmSchool(school)}}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }